class WebSocketService {
    constructor(url, token, messageCallback, errorCallback, closedConnection) {
        this.socket = null;
        this.url = url;
        this.token = token;
        this.shouldReconnect = true;
        this.reconnectInterval = 3000;
        this.maxRetries = 20;
        this.retryCount = 0;
        this.onMessageCallback = messageCallback;
        this.onErrorCallback = errorCallback;
        this.onCloseCallback = closedConnection;
    }

    connect() {
        this.shouldReconnect = true;
        if (this.socket) {
            console.log('Closing previous WebSocket before reconnecting...');
            this.socket.close();
        }

        if(!this.token){
            return;
        }
        if (!this.url) {
            // console.error('Cannot connect: No WebSocket URL provided.');
            return;
        }

        if (this.socket && (this.socket.readyState === WebSocket.OPEN || this.socket.readyState === WebSocket.CONNECTING)) {
            console.log('WebSocket is already connecting or connected.');
            return;
        }

        try {
            this.socket = new WebSocket(this.url);
            console.log('new ws connection with url: ', this.url)
        } catch (error) {
            console.error('Failed to create WebSocket:', error);
            return;
        }

        this.socket.onopen = () => {
            console.log('WebSocket connected with url: ', this.url);
            this.retryCount = 0; // Reset retry counter
        };

        this.socket.onmessage = (event) => {
            if (typeof this.onMessageCallback === 'function') {
                this.onMessageCallback(event.data);
            } else {
                console.warn('No onMessageCallback provided.');
            }
        };

        this.socket.onerror = (error) => {
            if (typeof this.onErrorCallback === 'function') {
                this.onErrorCallback(error);
            } else {
                console.warn('No onErrorCallback provided.');
            }
        };

        this.socket.onclose = (event) => {
            if (typeof this.onCloseCallback === 'function') {
                this.onCloseCallback(event);
            }
            console.log('Connection closed.');

            if (this.shouldReconnect && this.retryCount < this.maxRetries) {
                setTimeout(() => this.reconnect(), this.reconnectInterval);
            } else if (this.retryCount >= this.maxRetries) {
                console.error('Max reconnect attempts reached. Giving up.');
            }
        };
    }

    reconnect() {
        console.log('reconnection')
        this.retryCount++;
        const delay = Math.min(this.reconnectInterval * this.retryCount, 30000); // Limit max delay to 30s
        
        if(this.retryCount > this.maxRetries){
            this.retryCount = 0;
        }

        console.log(`Reconnecting (attempt #${this.retryCount}) in ${delay / 1000} for ${this.url}`);
        
        setTimeout(() => this.connect(), delay);
        
    }

    disconnect() {
        this.shouldReconnect = false;

        if (this.socket) {
            this.socket.onopen = null;
            this.socket.onmessage = null;
            this.socket.onerror = null;
            this.socket.onclose = null;

            if (this.socket.readyState === WebSocket.OPEN || this.socket.readyState === WebSocket.CONNECTING) {
                console.log('Closing WebSocket connection...');
                this.socket.close();
            }

            this.socket = null;
        }
    }

    sendMessage(message) {
        if (this.socket && this.socket.readyState === WebSocket.OPEN) {
            this.socket.send(message);
        } else {
            console.error('Cannot send message: WebSocket is not open.');
        }
    }
}

// export default WebSocketService;


export default WebSocketService;
